
    <div class="wrapper">
      <ul nz-menu nzMode="inline" nzTheme="light" [nzInlineCollapsed]="isCollapsed">
        <li
          nz-menu-item
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Home' : ''"
          [nzDisabled]="false"
          routerLink="/home"
          routerLinkActive="ant-menu-item-selected"
          (click)="goTo('/home')"
        >
          <span nz-icon nzType="home"></span>
          <span>Home</span>
        </li>

        <li 
          nz-menu-item
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Reportes' : ''"
          [nzDisabled]="!this.user?.esAdmin && !this.user?.esRRHH"
          routerLink="/reportes"
          routerLinkActive="ant-menu-item-selected"
          (click)="(this.user?.esAdmin || this.user?.esRRHH) && goTo('/reportes')"
        >
          <span nz-icon nzType="file-search"></span>
          <span>Reportes</span>
        </li>

        <li 
          nz-menu-item
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Beneficiarios Gestantes' : ''"
          [nzDisabled]="!this.user?.esRRHH && !this.user?.esMedico && !this.user?.esAdmin"
          routerLink="/beneficiarios"
          routerLinkActive="ant-menu-item-selected"
          (click)="(this.user?.esRRHH || this.user?.esMedico || this.user?.esAdmin) && goTo('/beneficiarios')"
        >
          <span nz-icon nzType="folder-open"></span>
          <span>Beneficiarios Gestantes</span>
        </li>
        <li 
          nz-menu-item
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Consulta de SGMM' : ''"
          [nzDisabled]="!this.user?.esRRHH && !this.user?.esColaborador && !this.user?.esAdmin && !this.user?.esMedico"
          routerLink="/consulta-sgmm"
          routerLinkActive="ant-menu-item-selected"
          (click)="( this.user?.esRRHH || this.user?.esColaborador || this.user?.esAdmin || this.user?.esMedico) && goTo('/consulta-sgmm')"
        >
          <span nz-icon nzType="hdd"></span>
          <span>Consulta de SGMM</span>
        </li>
        <li 
          nz-menu-item
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Catálogo' : ''"
          [nzDisabled]="!this.user?.esAdmin"
          routerLink="/catalogos"
          routerLinkActive="ant-menu-item-selected"
          (click)="this.user?.esAdmin && goTo('/catalogos')"
        >
          <span nz-icon nzType="book"></span>
          <span>Catálogo</span>
        </li>

        <li 
          nz-menu-item
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Roles' : ''"
          [nzDisabled]="!this.user?.esAdmin"
          routerLink="/roles"
          routerLinkActive="ant-menu-item-selected"
          (click)="this.user?.esAdmin && goTo('/roles')"
        >
          <span nz-icon nzType="team"></span>
          <span>Roles</span>
        </li>


        <li 
          nz-menu-item
          nz-tooltip
          nzTooltipPlacement="right"
          [nzTooltipTitle]="isCollapsed ? 'Histórico' : ''"
          [nzDisabled]=" !this.user?.esAdmin && !this.user?.esRRHH"
          routerLink="/historico"
          routerLinkActive="ant-menu-item-selected"
          (click)="(this.user?.esAdmin ||  this.user?.esRRHH) && goTo('/historico')"
        >
          <span nz-icon nzType="history"></span>
          <span>Histórico</span>
        </li>
        <li nz-menu-divider></li>
      </ul>
    </div>